import classNames from "classnames";
import PAImage from "component/design-system/images/PAImage";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import { colorMap } from "util/product/apparel";
import styles from "./colorOptions.module.scss";

const SWATCH_IMAGE_SIZE = {
  small: 26,
  large: 40,
};

interface IProps {
  colors: string[];
  selectedColor?: string;
  onSelect: (color: string) => void;
  size?: keyof typeof SWATCH_IMAGE_SIZE;
  className?: string;
}

/* Colour Options for merchandise variants */
const ColorOptions = ({
  colors, selectedColor, onSelect, size = "large", className,
}: IProps) => {
  const imageSize = SWATCH_IMAGE_SIZE[size];

  return (
    <div className={classNames(styles.color_container, className)}>
      {colors.map((color) => (
        <div
          key={color}
          className={classNames(styles.color, styles[size], { [styles.color_selected]: color === selectedColor })}
          onClick={() => onSelect(color)}
        >
          <PAImage
            src={getRelativeImagePath(colorMap[color])}
            alt={color}
            width={imageSize}
            height={imageSize}
          />
        </div>
      ))}
    </div>
  );
};

export default ColorOptions;
